<template>
  <v-card class="d-flex flex-column ma-5" style="height: calc(100% - 40px)">
    <v-card-text class="flex-grow-0">

      <v-card-item>
        <v-card-title class="text-headline-small">
          <v-icon :color="isSelectedDateToday ? 'green-darken-2' : 'blue-grey-darken-1'">{{ journalIcon() }}</v-icon>
          <span v-if="isSelectedDateToday" class="ml-2">
            Oggi:
          </span>
          <span v-else class="ml-2">
            Giornata:
          </span>
          {{ selectedDateLabel }}



        </v-card-title>
      </v-card-item>
    </v-card-text>
    <!-- <v-card-text class="d-flex justify-space-between align-center px-8"> -->
    <v-card-text class="d-flex justify-space-between align-center flex-grow-0">

      <v-btn color='blue-grey-darken-3' size="" class="pa-3 mx-2" @click="removeDay">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <div class="d-flex align-center">

        <v-btn prepend-icon="mdi-calendar" class="pa-3 mx-2" color="primary">
          seleziona
          <!-- {{ selectedDateLabel }}
          <span v-if="isSelectedDateToday" class="ml-2">
            - oggi
          </span> -->

          <v-dialog v-model="dialogSelectDate" activator="parent" width="auto" theme="dark">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row justify="space-around">
                    <v-date-picker v-model="selectedDate" show-adjacent-months color="blue-darken-3"
                        @update:modelValue="selectedDateUpdated" :min="minDate" :max="todayISOString">
                      <template #title>
                        seleziona data
                      </template>
                    </v-date-picker>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="flex-column">
                <!-- <v-btn  size="large" variant="elevated" color="blue-darken-3" @click="dialogSelectDate = false">
                    <template v-slot:prepend>
                      <v-icon class="ml-2">mdi-check</v-icon>
                    </template>
                    Seleziona
                  </v-btn> -->

                <v-btn size="large" variant="elevated" color="blue-darken-3" @click="selectToday">
                  <template v-slot:prepend>
                    <v-icon class="ml-2">mdi-calendar-star-four-points</v-icon>
                  </template>
                  Oggi
                </v-btn>
                <v-btn size="large" variant="outlined" color="white" @click="dialogSelectDate = false"
                    class="mx-0 my-3">
                  <template v-slot:prepend>
                    <v-icon class="ml-2">mdi-chevron-down</v-icon>
                  </template>
                  Indietro</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-btn>

      </div>




      <v-btn color='blue-grey-darken-3' size="" class="pa-3 mx-2" @click="addDay"
          :disabled="isSelectedDateToday">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-text>



    <v-card-text class="d-flex flex-column flex-grow-1">

      <v-textarea v-model="currentText" :readonly="isJournalEntryLocked()" placeholder="..."
          class="d-flex flex-column flex-grow-1 ma-0" @update:model-value="onUpdateText" style="height: 100%"
          :rows="null" persistent-hint>
        <template #details>
          <v-icon :color="journalDetailsIcon().color" class="mr-2">{{ journalDetailsIcon().mdi }}</v-icon>
          {{ journalDetailsText() }}
        </template>
      </v-textarea>

    </v-card-text>

  </v-card>
</template>

<script setup>

import { ref, computed, onMounted, onUnmounted } from "vue";
import router from "@/router";


import { useDataStore } from "@/store/data";

const dataStore = useDataStore();


const dialogSelectDate = ref(false);
const currentText = ref("");


const selectedDate = ref(new Date(Date.now()))
selectedDate.value.setHours(12, 0, 0);


const selectedDateLabel = computed(() => {
  return selectedDate.value.toLocaleDateString(undefined, { // you can use undefined as first argument
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
})


const selectedDateIso = computed(() => {

  return selectedDate.value.toISOString().split('T')[0]
})


const minDate = computed(() => {

  // 100 days ago

  return (new Date(Date.now() - 100 * 24 * 60 * 60 * 1000)).toISOString()
})


const today = computed(() => {

  const todayDate = new Date(Date.now())

  todayDate.setHours(12, 0, 0);

  return todayDate
})


const todayISOString = computed(() => {
  // return (new Date(today)).value
  return today.value.toISOString()
})


const todayLocaleDateString = computed(() => {
  return new Date(today.value).toLocaleDateString().split(".")[0]
})


const isSelectedDateToday = computed(() => {
  return selectedDate.value.toLocaleDateString() === todayLocaleDateString.value
})


const addDay = () => {
  if (isSelectedDateToday.value) return
  selectedDate.value = new Date(selectedDate.value.getTime() + 86400000)
  selectedDateUpdated()
}


const removeDay = () => {
  selectedDate.value = new Date(selectedDate.value.getTime() - 86400000)
  selectedDateUpdated()
}


const selectToday = () => {
  selectedDate.value = new Date(Date.now())
  selectedDate.value.setHours(12, 0, 0);
  dialogSelectDate.value = false
}


const isJournalEntryLocked = () => {

  const days = 10

  const today = (new Date(Date.now()))
  // const today = (new Date(Date.now())).setHours(12,0,0);  // ???
  // debugger
  const diffTime = Math.abs(today - selectedDate.value);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return days < diffDays

}


const journalIcon = () => {
  if (isJournalEntryLocked()) return "mdi-lock"
  else return "mdi-pencil"
}

const journalDetailsText = () => {
  let txt = ""
  if (isJournalEntryLocked()) {
    txt = "giornata non modificabile, è passato troppo tempo"
  }
  else {
    txt = "salvataggio automatico"
  }

  // txt = txt + " - " + dataStore.userData.tracker?.journal[selectedDateIso.value]?.state
  // txt = txt + " - " +
  //   typeof dataStore.userData.tracker?.journal[selectedDateIso.value]?.state

  return txt
}


const journalDetailsIcon = () => {
  let obj = {
    mdi: "mdi-cloud-off",
    color: "grey"
  }

  if (selectedDate.value.state === 201) {
    obj = {
      mdi: "mdi-cloud-check",
      color: "success"
    }
  }
  return obj
}


const onUpdateText = () => {
  if (currentText.value.trim() === "" || currentText.value === null) {
    console.log("no text, deleting entry")
    delete dataStore.userData.tracker.journal[selectedDateIso.value]
    return
  }
  dataStore.userData.tracker.journal[selectedDateIso.value] = {}
  dataStore.userData.tracker.journal[selectedDateIso.value].text = currentText.value;
  dataStore.userData.tracker.journal[selectedDateIso.value].state = null;
  dataStore.save()
}


onMounted(async () => {
  if (router.currentRoute.value.query.date) {

    const queriedDate = new Date(router.currentRoute.value.query.date)


    queriedDate.setHours(12, 0, 0);

    selectedDate.value = queriedDate

    if (isNaN(queriedDate)) {
      console.log("📅 date not valid, setting today as current date")
      selectedDate.value = today.value
    }
    if (queriedDate > today.value) {
      console.log("📅 date in the future, setting today as current date")
      selectedDate.value = today.value
    }

    currentText.value = dataStore.userData.tracker.journal?.[selectedDateIso.value]?.text
  }

  setVTextareaHeight()

  // adoptStyleSheetForAvailableDates()
  enableStyleSheetLegacy()
})


onUnmounted(() => {
  // ditchStyleSheetForAvailableDates()
  disableStyleSheetLegacy()

})

const selectedDateUpdated = () => {
  //

  selectedDate.value.setHours(12, 0, 0);

  dialogSelectDate.value = false


  router.push(
    {
      name: "journal",
      query: { date: selectedDateIso.value }
    });

  currentText.value = dataStore.userData.tracker.journal?.[selectedDateIso.value]?.text

  // ditchStyleSheetForAvailableDates()
  // adoptStyleSheetForAvailableDates()
  enableStyleSheetLegacy()
  disableStyleSheetLegacy()

}


const setVTextareaHeight = () => {
  const vTextarea = document.querySelector('.v-textarea')
  const vTextareaInner = document.querySelector('.v-textarea .v-input__control')
  const textarea = document.querySelector('.v-textarea textarea')

  vTextarea.style.height = "100%"
  vTextareaInner.style.flexGrow = "1"
  textarea.style.height = "100%"
}


const enableStyleSheetLegacy = () => {

  let sheetTxt = ""
  const availableDates = []

  console.log(dataStore.userData.tracker.journal)
  for (const entry in dataStore.userData.tracker.journal) {
    if (entry) {
      console.log(entry)
      availableDates.push(`.v-date-picker-month__day[data-v-date="${entry}"] > .v-btn > .v-btn__content`)
    }
  }

  sheetTxt += availableDates.join(",\n")
  sheetTxt += " { color: yellow; }\n"
  sheetTxt += `.v-date-picker-month__day > .v-btn.v-btn--variant-outlined > .v-btn__content, \n`
  sheetTxt += `.v-date-picker-month__day > .v-btn.bg-blue-darken-3  > .v-btn__content \n`
  sheetTxt += `{ color: white; }\n`


  const cssForJournal = document.createElement('style');
  cssForJournal.setAttribute("id", "cssForJournal");


  cssForJournal.appendChild(document.createTextNode(sheetTxt));
  document.getElementsByTagName('head')[0].appendChild(cssForJournal);
}


const disableStyleSheetLegacy = () => {
  const cssForJournal = document.getElementById("cssForJournal");
  if (cssForJournal) {
    cssForJournal.remove()
  }
}



// // ios15.6 incompatible
// const sheet = new CSSStyleSheet();
// const ditchStyleSheetForAvailableDates = () => {
//   document.adoptedStyleSheets = []
//   //Adopt the sheet into the shadow DOM
// }
// const adoptStyleSheetForAvailableDates = () => {
//   // Create an empty "constructed" stylesheet
//   // Apply a rule to the sheet
//   // generate rules


//   let sheetTxt = ""
//   const availableDates = []

//   console.log(dataStore.userData.tracker.journal)
//   for (const entry in dataStore.userData.tracker.journal) {
//     if (entry) {
//       console.log(entry)
//       availableDates.push(`.v-date-picker-month__day[data-v-date="${entry}"] > .v-btn > .v-btn__content`)
//     }
//   }

//   sheetTxt += `${availableDates.join(",\n")}  { color: yellow; }\n`
//   sheetTxt += `.v-date-picker-month__day > .v-btn.v-btn--variant-outlined > .v-btn__content, \n`
//   sheetTxt += `.v-date-picker-month__day > .v-btn.bg-blue-darken-3  > .v-btn__content \n`
//   sheetTxt += `{ color: white; }\n`

//   sheet.replaceSync(sheetTxt);

//   document.adoptedStyleSheets = [sheet]
//   // document.adoptedStyleSheets = [...document.adoptedStyleSheets, sheet]   // boh

// }


</script>

<style scoped>
.v-btn--active .date-color {
  color: #fff;
}
</style>
<style>
/* https://stackoverflow.com/questions/15493965/define-global-css-classes-using-javascript-or-jquery */
</style>
